import { render } from "./MeasurementBlock.vue?vue&type=template&id=f2abcd08"
import script from "./MeasurementBlock.vue?vue&type=script&lang=js"
export * from "./MeasurementBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__